import React from 'react'

function SubjectGrades() {
  return (
    <div>
      SubjectGrades
    </div>
  )
}

export default SubjectGrades
